module.exports = "https://static.wmbcdn.com/uniweb/images/ab5237d8fa6ba9ce08f94860e0dbe9c5.svg";